webpackJsonp([214286880276331],{

/***/ 1459:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/how-it-works-banner.d849d153.jpg";

/***/ }),

/***/ 1488:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/process-detail-1b.f64485b6.png";

/***/ }),

/***/ 1489:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/process-detail-2a.afaa702e.png";

/***/ }),

/***/ 1490:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/process-detail-2b.6bbb7d72.png";

/***/ }),

/***/ 1491:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/process-detail-3a.f7560b71.png";

/***/ }),

/***/ 1492:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/process-detail-3b.e97299b9.png";

/***/ }),

/***/ 1493:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/process-detail-4a.eb4617c7.png";

/***/ }),

/***/ 1494:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/process-detail-4b.6fdf8d59.png";

/***/ }),

/***/ 1495:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/process-detail-a.892c7047.png";

/***/ }),

/***/ 1496:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/process-detail-c.2903732a.svg";

/***/ }),

/***/ 1497:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1498:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT_Process-01.12ade7f6.png";

/***/ }),

/***/ 1499:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT_Process-02.f42d9f59.png";

/***/ }),

/***/ 1500:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT_Process-03.b71fd446.png";

/***/ }),

/***/ 1501:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT_Process-04.5fe6d316.png";

/***/ }),

/***/ 1502:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT_Process-05.444d8c3b.png";

/***/ }),

/***/ 1503:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT_Process-06.cf2d3ae4.png";

/***/ }),

/***/ 1504:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT_Process-07.685d3d5a.png";

/***/ }),

/***/ 1505:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/MT_Process-08.d59d4a8c.png";

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    padding: 0 0 160px;\n  '], ['\n    padding: 0 0 160px;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    ', '\n  '], ['\n    ', '\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n      font-size: 36px;\n      line-height: 43px;\n    '], ['\n      font-size: 36px;\n      line-height: 43px;\n    ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    flex-direction: row;\n  '], ['\n    flex-direction: row;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    order: inherit;\n    width: 60%;\n  '], ['\n    order: inherit;\n    width: 60%;\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n      top: auto;\n      left: -60px;\n    '], ['\n      top: auto;\n      left: -60px;\n    ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n    width: 40%;\n    order: inherit;\n\n    ', '\n  '], ['\n    width: 40%;\n    order: inherit;\n\n    ', '\n  ']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n      font-size: 64px;\n      line-height: 77px;\n    '], ['\n      font-size: 64px;\n      line-height: 77px;\n    ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n    display: flex;\n    flex-wrap: wrap;\n  '], ['\n    display: flex;\n    flex-wrap: wrap;\n  ']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n      margin-right: 0;\n    '], ['\n      margin-right: 0;\n    ']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n      margin-right: 40px;\n    '], ['\n      margin-right: 40px;\n    ']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n    margin-right: 40px;\n    width: calc((100% / 2) - (40px / 2));\n  '], ['\n    margin-right: 40px;\n    width: calc((100% / 2) - (40px / 2));\n  ']),
	    _templateObject13 = _taggedTemplateLiteralLoose(['\n    width: calc((100% / 4) - (120px / 4));\n  '], ['\n    width: calc((100% / 4) - (120px / 4));\n  ']),
	    _templateObject14 = _taggedTemplateLiteralLoose(['\n    padding: 100px 0;\n  '], ['\n    padding: 100px 0;\n  ']),
	    _templateObject15 = _taggedTemplateLiteralLoose(['\n      font-size: 60px;\n      line-height: 72px;\n      letter-spacing: -1.1px;\n    '], ['\n      font-size: 60px;\n      line-height: 72px;\n      letter-spacing: -1.1px;\n    ']),
	    _templateObject16 = _taggedTemplateLiteralLoose(['\n    background-position: top right;\n    min-height: 960px;\n\n    &::before {\n      background-color: rgba(43, 88, 153, 0.3);\n    }\n  '], ['\n    background-position: top right;\n    min-height: 960px;\n\n    &::before {\n      background-color: rgba(43, 88, 153, 0.3);\n    }\n  ']),
	    _templateObject17 = _taggedTemplateLiteralLoose(['\n    padding: 100px 0 160px;\n  '], ['\n    padding: 100px 0 160px;\n  ']),
	    _templateObject18 = _taggedTemplateLiteralLoose(['\n    padding: 30px 0 40px;\n  '], ['\n    padding: 30px 0 40px;\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styles = __webpack_require__(6);
	
	var _reactScroll = __webpack_require__(76);
	
	var _howItWorksBanner = __webpack_require__(1459);
	
	var _howItWorksBanner2 = _interopRequireDefault(_howItWorksBanner);
	
	var _MT_Process = __webpack_require__(1498);
	
	var _MT_Process2 = _interopRequireDefault(_MT_Process);
	
	var _MT_Process3 = __webpack_require__(1499);
	
	var _MT_Process4 = _interopRequireDefault(_MT_Process3);
	
	var _MT_Process5 = __webpack_require__(1500);
	
	var _MT_Process6 = _interopRequireDefault(_MT_Process5);
	
	var _MT_Process7 = __webpack_require__(1501);
	
	var _MT_Process8 = _interopRequireDefault(_MT_Process7);
	
	var _MT_Process9 = __webpack_require__(1502);
	
	var _MT_Process10 = _interopRequireDefault(_MT_Process9);
	
	var _MT_Process11 = __webpack_require__(1503);
	
	var _MT_Process12 = _interopRequireDefault(_MT_Process11);
	
	var _MT_Process13 = __webpack_require__(1504);
	
	var _MT_Process14 = _interopRequireDefault(_MT_Process13);
	
	var _MT_Process15 = __webpack_require__(1505);
	
	var _MT_Process16 = _interopRequireDefault(_MT_Process15);
	
	var _processDetailA = __webpack_require__(1495);
	
	var _processDetailA2 = _interopRequireDefault(_processDetailA);
	
	var _processDetailC = __webpack_require__(1496);
	
	var _processDetailC2 = _interopRequireDefault(_processDetailC);
	
	var _processDetail1b = __webpack_require__(1488);
	
	var _processDetail1b2 = _interopRequireDefault(_processDetail1b);
	
	var _processDetail2a = __webpack_require__(1489);
	
	var _processDetail2a2 = _interopRequireDefault(_processDetail2a);
	
	var _processDetail2b = __webpack_require__(1490);
	
	var _processDetail2b2 = _interopRequireDefault(_processDetail2b);
	
	var _processDetail3a = __webpack_require__(1491);
	
	var _processDetail3a2 = _interopRequireDefault(_processDetail3a);
	
	var _processDetail3b = __webpack_require__(1492);
	
	var _processDetail3b2 = _interopRequireDefault(_processDetail3b);
	
	var _processDetail4a = __webpack_require__(1493);
	
	var _processDetail4a2 = _interopRequireDefault(_processDetail4a);
	
	var _processDetail4b = __webpack_require__(1494);
	
	var _processDetail4b2 = _interopRequireDefault(_processDetail4b);
	
	var _processDetailFinal = __webpack_require__(1497);
	
	var _processDetailFinal2 = _interopRequireDefault(_processDetailFinal);
	
	var _shared = __webpack_require__(7);
	
	var _FacebookTags = __webpack_require__(108);
	
	var _FacebookTags2 = _interopRequireDefault(_FacebookTags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var sp = _styles.theme.sp,
	    colors = _styles.theme.colors;
	
	
	var ProcessDetail = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__ProcessDetail'
	})(['padding:0 0 100px;', ';'], _styles.media.tablet(_templateObject));
	
	var ProcessDetailHeader = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__ProcessDetailHeader'
	})(['margin-bottom:30px;', ';h2{margin:0 0 10px;font-size:32px;line-height:40px;font-weight:700;', ';}p{margin:0;color:', ';}'], _styles.media.tablet(_templateObject2, function (props) {
	  return props.reverse && '\n      text-align: right;\n    ';
	}), _styles.media.tablet(_templateObject3), colors.royal);
	
	var ProcessDetailWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__ProcessDetailWrapper'
	})(['display:flex;flex-direction:column;', ';'], _styles.media.tablet(_templateObject4));
	
	var ProcessDetailPrimary = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__ProcessDetailPrimary'
	})(['order:1;', ';img{display:block;position:relative;max-width:100%;}'], _styles.media.tablet(_templateObject5));
	
	var ProcessDetailSecondary = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__ProcessDetailSecondary'
	})(['display:flex;align:items:center;justify-content:center;order:2;background-image:url(\'', '\');background-size:contain;background-position:top center;background-repeat:no-repeat;img{position:relative;align-self:center;top:-40px;max-width:100%;z-index:1;', ';}', ';'], function (props) {
	  return props.src;
	}, _styles.media.tablet(_templateObject6), _styles.media.tablet(_templateObject7, function (props) {
	  return props.reverse && '\n      img {\n        right: -70px;\n        left: auto;\n      }\n    ';
	}));
	
	var ProcessDetailFinal = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__ProcessDetailFinal'
	})(['position:relative;text-align:center;background-image:url(\'', '\');background-size:contain;background-position:center center;background-repeat:no-repeat;h2{margin:0 0 160px;font-size:50px;line-height:60px;font-weight:700;padding:20px 0;', ';}'], _processDetailFinal2.default, _styles.media.tablet(_templateObject8));
	
	var Wrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__Wrapper'
	})(['background-color:', ';'], colors.white);
	
	var Grid = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__Grid'
	})(['', ';'], _styles.media.phablet(_templateObject9));
	
	var GridItem = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__GridItem'
	})(['margin-bottom:20px;background-color:', ';padding:60px 30px;margin-bottom:40px;border:1px solid rgba(43,88,153,0.2);box-shadow:0 2px 4px rgba(0,0,0,0.1);border-radius:6px;text-align:center;min-height:340px;&:nth-child(2n){', ';', ';}&:nth-child(4n){', ';}', ';', ';'], colors.blueIce, _styles.media.phablet(_templateObject10), _styles.media.desktop(_templateObject11), _styles.media.desktop(_templateObject10), _styles.media.phablet(_templateObject12), _styles.media.desktop(_templateObject13));
	
	var GridTitle = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__GridTitle'
	})(['font-size:16px;line-height:20px;']);
	
	var GridText = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__GridText'
	})(['font-size:14px;line-height:20px;color:', ';'], colors.royal);
	
	var GridIcon = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__GridIcon'
	})(['display:inline-block;margin:30px 0;width:100px;height:100px;border-radius:50%;background-color:', ';img{max-width:100%;}'], colors.white);
	
	var Banner = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__Banner'
	})(['position:relative;background-image:url(\'', '\');background-size:cover;background-position:top right -150px;background-repeat:no-repeat;padding:60px 0 100px;', ';h1{color:', ';max-width:600px;font-size:32px;line-height:40px;letter-spacing:-0.8px;margin-top:', ';margin-bottom:', ';font-weight:700;', ';}&::before{position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(43,88,153,0.7);content:\'\';}', ';'], function (props) {
	  return props.src;
	}, _styles.media.tablet(_templateObject14), colors.white, sp.l, sp.xl, _styles.media.tablet(_templateObject15), _styles.media.tablet(_templateObject16));
	
	var Wedge = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__Wedge'
	})(['position:absolute;width:110%;bottom:0;left:-10%;&::after{position:absolute;left:0;bottom:0;width:100%;height:1px;background-color:', ';content:\'\';}svg{display:block;}'], colors.blueIce);
	
	var Intro = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__Intro'
	})(['background-color:', ';padding:60px 0 100px;margin-bottom:100px;', ';h2{margin:0 0 20px;font-size:36px;line-height:43px;}'], colors.blueIce, _styles.media.tablet(_templateObject17));
	
	var VideoPlaceHolder = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__VideoPlaceHolder'
	})(['background-color:', ';padding:20px 0 20px;margin-bottom:100px;', ';h2{margin:0 0 20px;font-size:36px;line-height:43px;}'], colors.blueIce, _styles.media.tablet(_templateObject18));
	
	var Process = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__Process'
	})(['padding:0 0 160px;']);
	
	var ProcessHeader = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'how-it-works__ProcessHeader'
	})(['margin:0 0 60px;text-align:center;h2{margin:0 0 10px;font-size:36px;line-height:43px;}p{margin:0;}']);
	
	function HowItWorks() {
	  var breadcrumbs = [{
	    name: 'Home',
	    link: '/'
	  }, {
	    name: 'How It Works',
	    link: '/how-it-works'
	  }];
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(_shared.SeoTags, {
	      title: 'How MarketTap\'s Platform Works | MarketTap',
	      description: 'MarketTap is a simple marketing platform that allows you to buy on demand marketing services and track their delivery. Interested? Get in touch today.'
	    }),
	    _react2.default.createElement(_FacebookTags2.default, {
	      fbUrl: ("https://markettap.com") + '/how-it-works/',
	      fbTitle: 'How MarketTap\'s Platform Works | MarketTap',
	      fbDescription: 'MarketTap is a simple marketing platform that allows you to buy on demand marketing services and track their delivery. Interested? Get in touch today.',
	      fbImage: _howItWorksBanner2.default
	    }),
	    _react2.default.createElement(
	      Banner,
	      { src: _howItWorksBanner2.default },
	      _react2.default.createElement(
	        Wedge,
	        null,
	        _react2.default.createElement(
	          'svg',
	          { viewBox: '0 0 1400 100' },
	          _react2.default.createElement('polygon', { points: '0 0 1400 100 0 100', fill: '#f7faff' })
	        )
	      ),
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        _react2.default.createElement(_shared.Breadcrumbs, { breadcrumbs: breadcrumbs, left: true, light: true }),
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Our platform is changing the way businesses manage their marketing.'
	        ),
	        _react2.default.createElement(
	          _reactScroll.Link,
	          { to: 'howItWorks', smooth: true, duration: 1000 },
	          _react2.default.createElement(
	            _shared.Button,
	            { yellow: true, scroll: true },
	            'Find out how'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactScroll.Element,
	      { name: 'howItWorks' },
	      _react2.default.createElement(
	        Intro,
	        null,
	        _react2.default.createElement(
	          _shared.Container,
	          { narrow: true, centerText: true },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'How it works'
	          )
	        ),
	        _react2.default.createElement(
	          VideoPlaceHolder,
	          null,
	          _react2.default.createElement(
	            _shared.Container,
	            null,
	            _react2.default.createElement(_shared.VideoCallout, {
	              heading: '',
	              subheading: '',
	              buttonText: '',
	              videoThumbnail: '',
	              videoID: 'yd7qih7mq8'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _shared.Container,
	          { narrow: true, centerText: true },
	          _react2.default.createElement(
	            'p',
	            null,
	            'With MarketTap, you are able to shop services, chat with us live, track the progress of your projects and more\u2026 all within one platform! It\u2019s as easy and convenient as shopping online.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      ProcessDetail,
	      null,
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        _react2.default.createElement(
	          ProcessDetailHeader,
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            '1. Shop Services'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Browse our range of pay-as-you-go marketing services.'
	          )
	        ),
	        _react2.default.createElement(
	          ProcessDetailWrapper,
	          null,
	          _react2.default.createElement(
	            ProcessDetailPrimary,
	            null,
	            _react2.default.createElement('img', { src: _processDetailA2.default, alt: '' })
	          ),
	          _react2.default.createElement(
	            ProcessDetailSecondary,
	            { src: _processDetailC2.default },
	            _react2.default.createElement('img', { src: _processDetail1b2.default, alt: '' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      ProcessDetail,
	      null,
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        _react2.default.createElement(
	          ProcessDetailHeader,
	          { reverse: true },
	          _react2.default.createElement(
	            'h2',
	            null,
	            '2. Book Services'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Add to cart and checkout within our platform.'
	          )
	        ),
	        _react2.default.createElement(
	          ProcessDetailWrapper,
	          null,
	          _react2.default.createElement(
	            ProcessDetailSecondary,
	            { reverse: true, src: _processDetailC2.default },
	            _react2.default.createElement('img', { src: _processDetail2b2.default, alt: '' })
	          ),
	          _react2.default.createElement(
	            ProcessDetailPrimary,
	            null,
	            _react2.default.createElement('img', { src: _processDetail2a2.default, alt: '' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      ProcessDetail,
	      null,
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        _react2.default.createElement(
	          ProcessDetailHeader,
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            '3. Add Details'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Answer some initial kick off questions and your project begins!'
	          )
	        ),
	        _react2.default.createElement(
	          ProcessDetailWrapper,
	          null,
	          _react2.default.createElement(
	            ProcessDetailPrimary,
	            null,
	            _react2.default.createElement('img', { src: _processDetail3a2.default, alt: '' })
	          ),
	          _react2.default.createElement(
	            ProcessDetailSecondary,
	            { src: _processDetailC2.default },
	            _react2.default.createElement('img', { src: _processDetail3b2.default, alt: '' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      ProcessDetail,
	      null,
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        _react2.default.createElement(
	          ProcessDetailHeader,
	          { reverse: true },
	          _react2.default.createElement(
	            'h2',
	            null,
	            '4. Review & Approve'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Finished projects are uploaded for your review and approval'
	          )
	        ),
	        _react2.default.createElement(
	          ProcessDetailWrapper,
	          null,
	          _react2.default.createElement(
	            ProcessDetailSecondary,
	            { reverse: true, src: _processDetailC2.default },
	            _react2.default.createElement('img', { src: _processDetail4b2.default, alt: '' })
	          ),
	          _react2.default.createElement(
	            ProcessDetailPrimary,
	            null,
	            _react2.default.createElement('img', { src: _processDetail4a2.default, alt: '' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      ProcessDetailFinal,
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        '5.See Results'
	      )
	    ),
	    _react2.default.createElement(
	      Process,
	      null,
	      _react2.default.createElement(
	        _shared.Container,
	        null,
	        _react2.default.createElement(
	          ProcessHeader,
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Our process for delivering results'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'While each individual project is different, here are the typical stages of our project delivery:'
	          )
	        ),
	        _react2.default.createElement(
	          Grid,
	          null,
	          _react2.default.createElement(
	            GridItem,
	            null,
	            _react2.default.createElement(
	              GridTitle,
	              null,
	              '1. Your Input'
	            ),
	            _react2.default.createElement(
	              GridIcon,
	              null,
	              _react2.default.createElement('img', { src: _MT_Process2.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              GridText,
	              null,
	              'As soon as you check out, you will be presented with initial kick off questions. Once these are answered, your project officially starts!'
	            )
	          ),
	          _react2.default.createElement(
	            GridItem,
	            null,
	            _react2.default.createElement(
	              GridTitle,
	              null,
	              '2. Assign Team'
	            ),
	            _react2.default.createElement(
	              GridIcon,
	              null,
	              _react2.default.createElement('img', { src: _MT_Process4.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              GridText,
	              null,
	              'Within 24 hours, MarketTap experts are assigned to you. Your Success Manager will reach out to schedule an initial call.'
	            )
	          ),
	          _react2.default.createElement(
	            GridItem,
	            null,
	            _react2.default.createElement(
	              GridTitle,
	              null,
	              '3. Creation'
	            ),
	            _react2.default.createElement(
	              GridIcon,
	              null,
	              _react2.default.createElement('img', { src: _MT_Process6.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              GridText,
	              null,
	              'Our experts get to work on your project!'
	            )
	          ),
	          _react2.default.createElement(
	            GridItem,
	            null,
	            _react2.default.createElement(
	              GridTitle,
	              null,
	              '4. Internal Review'
	            ),
	            _react2.default.createElement(
	              GridIcon,
	              null,
	              _react2.default.createElement('img', { src: _MT_Process8.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              GridText,
	              null,
	              'All projects go through several internal quality reviews and revisions to ensure they are up to MarketTap standards.'
	            )
	          ),
	          _react2.default.createElement(
	            GridItem,
	            null,
	            _react2.default.createElement(
	              GridTitle,
	              null,
	              '5. Project Upload'
	            ),
	            _react2.default.createElement(
	              GridIcon,
	              null,
	              _react2.default.createElement('img', { src: _MT_Process10.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              GridText,
	              null,
	              'Your project is completed! You will be notified through the platform as soon as any completed work is uploaded.'
	            )
	          ),
	          _react2.default.createElement(
	            GridItem,
	            null,
	            _react2.default.createElement(
	              GridTitle,
	              null,
	              '6. Your Review'
	            ),
	            _react2.default.createElement(
	              GridIcon,
	              null,
	              _react2.default.createElement('img', { src: _MT_Process12.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              GridText,
	              null,
	              'Your Success Manager will reach out to schedule a call to review the project together and answer any questions.'
	            )
	          ),
	          _react2.default.createElement(
	            GridItem,
	            null,
	            _react2.default.createElement(
	              GridTitle,
	              null,
	              '7. Implementation'
	            ),
	            _react2.default.createElement(
	              GridIcon,
	              null,
	              _react2.default.createElement('img', { src: _MT_Process14.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              GridText,
	              null,
	              'For services like social media advertising and SEO, we implement the recommendations we created for you.'
	            )
	          ),
	          _react2.default.createElement(
	            GridItem,
	            null,
	            _react2.default.createElement(
	              GridTitle,
	              null,
	              '8. Measure & Report'
	            ),
	            _react2.default.createElement(
	              GridIcon,
	              null,
	              _react2.default.createElement('img', { src: _MT_Process16.default, alt: '' })
	            ),
	            _react2.default.createElement(
	              GridText,
	              null,
	              'For services like social media advertising and SEO, we will present relevant and ongoing metrics reports to measure the success of your project.'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = HowItWorks;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-how-it-works-js-22e2734896aa171a78a8.js